import { useNavigate } from "react-router-dom"
import styled from "styled-components"

const Container = styled.div`
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #2db2c8;
  }
`

interface CustomerNameContainerProps {
  id: number | null
  name: string
  isInstalled: boolean
  showDashOnEmptyName?: boolean
  isVendor?: boolean
  onClick?: () => void
  deviceSN?: string | null
}

const CustomerNameContainer = ({
  id,
  name,
  showDashOnEmptyName,
  isInstalled,
  isVendor,
  deviceSN,
}: CustomerNameContainerProps) => {
  const navigate = useNavigate()
  const handleCustomerClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    if (!id) return

    const queryParams = new URLSearchParams({ openSidebar: "true" })
    if (deviceSN) {
      queryParams.set("selectedDevice", deviceSN)
    }
    navigate(`/customers/${id}/details?${queryParams.toString()}`)
  }

  const getCustomerName = () => {
    if (!isInstalled) {
      return ""
    }

    if (name && id) {
      return name
    }

    if (id) {
      return "Customer details"
    }

    return ""
  }

  const customerName = getCustomerName()

  if (showDashOnEmptyName && !customerName && !isVendor) {
    return <span>-</span>
  }

  if (isVendor && name) {
    return <span>{name || "-"}</span>
  }

  return <Container onClickCapture={handleCustomerClick}>{customerName}</Container>
}

export default CustomerNameContainer
